import type { ReactNode } from 'react';

export const symbol_keyboard_backspace: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m236-451 145 145q9 9 8.5 21t-9.5 21q-9 9-21.5 9t-21.5-9L141-460q-5-5-7-10t-2-11q0-6 2-11t7-10l197-197q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L236-511h574q13 0 21.5 8.5T840-481q0 13-8.5 21.5T810-451H236Z"
		/>
	</svg>
);
